export const en: Record<string, string> = {
    'nav.home': 'Home',
    'nav.overtime': 'Requests',
    'nav.payslip': 'Payslip',
    'nav.account': 'Account',

    'common.loading': 'Loading…',
    'common.saving': 'Saving…',
    'common.processing': 'Processing…',
    'common.saved': 'Saved',
    'common.save_failed': 'Save failed',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.back': 'Back',
    'common.close': 'Close',
    'common.try_again': 'Try again',

    'auth.login_title': 'Sign in to Attendance',
    'auth.login_subtitle': 'Use your Satutim account to start clocking in.',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.login_btn': 'Sign in',
    'auth.login_with_satutim': 'Sign in with Satutim',
    'auth.login_with_satutim_hint': 'Secure & one-click. Account linked to satutim.id.',
    'auth.feature_secure': 'No password entry in this app',
    'auth.feature_fast': 'One sign-in, straight to clock-in',
    'auth.feature_notif': 'Shift, overtime, payslip notifications',
    'auth.login_failed': 'Wrong email or password.',
    'auth.sso.exchanging': 'Connecting account…',
    'auth.sso.failed': 'Sign-in link expired or invalid. Please log in manually.',
    'auth.logout': 'Sign out',
    'auth.no_account': 'Don\'t have an account? Register at satutim.id first.',

    'workspace.switch': 'Switch workspace',
    'workspace.empty': 'You\'re not in any workspace yet.',
    'workspace.switch_hint': 'Attendance is only recorded in, and visible to, the workspace you pick.',
    'workspace.recorded_in': 'Attendance is recorded in workspace',
    'workspace.change': 'Change',
    'workspace.owned_hint': 'This is your own workspace — make sure it isn\'t your company\'s.',
    'workspace.chip_attendance_on': 'Attendance on',
    'workspace.chip_attendance_off': 'Attendance off',
    'workspace.chip_owned': 'Yours',
    'workspace.off_title': 'Attendance is not turned on',
    'workspace.off_body_prefix': 'Attendance is not turned on in workspace',
    'workspace.off_ask_owner': 'Ask this workspace\'s owner/admin to turn on Attendance, or pick another workspace.',
    'workspace.off_ask_owner_named': 'Ask {owner} (this workspace\'s owner) to turn on Attendance, or pick another workspace.',
    'workspace.off_others_title': 'Attendance is on in another workspace',
    'workspace.off_others_hint': 'Clocking in for work? Pick your company\'s workspace so your manager & HR can see it.',
    'workspace.switch_to': 'Switch to {name}',
    'workspace.off_reload': 'Reload',
    'workspace.off_reload_failed': 'Couldn\'t reload the workspace list. The server is busy or you\'re offline — try again shortly.',
    'workspace.owner_warn_title': '{name} is your own workspace',
    'workspace.owner_warn_body': 'If you are an employee clocking in for your company, do NOT turn on Attendance here. Attendance in this workspace is recorded SEPARATELY and your company will not see it. Ask your company admin to turn on Attendance in the company workspace, then pick that workspace.',
    'workspace.owner_warn_ok': 'Only turn it on here if this workspace is for your own business/team.',
    'workspace.enable_here': 'Turn on Attendance in {name}',
    'workspace.enable_confirm': 'Are you sure? All attendance will be recorded in {name}, separate from any company attendance.',
    'workspace.enable_confirm_others': 'Are you sure? Your company\'s Attendance is already on in another workspace (see above). Attendance in {name} will NOT be visible to your company.',
    'workspace.enable_confirm_btn': 'Yes, turn it on here',
    'workspace.enable_done': 'Attendance is on in {name}.',
    'workspace.enable_failed': 'Could not turn on Attendance. Please try again shortly.',
    'workspace.load_error_title': "Couldn't load your workspace",
    'workspace.load_error_body': 'The server is busy or your connection dropped. Wait a moment, then tap Try again.',

    'mode.office': 'Office',
    'mode.wfh': 'WFH',
    'mode.wfa': 'WFA',
    'mode.visit': 'Visit',
    'mode_desc.office': 'On-site, needs GPS & WiFi',
    'mode_desc.wfh': 'Working from home',
    'mode_desc.wfa': 'Working from anywhere',
    'mode_desc.visit': 'Client visit / fieldwork',

    'home.greeting_morning': 'Good morning',
    'home.greeting_noon': 'Good day',
    'home.greeting_afternoon': 'Good afternoon',
    'home.greeting_evening': 'Good evening',
    'home.working': 'Working',
    'home.work_duration': 'work duration',
    'home.shift_remaining': '{duration} until shift ends',
    'home.shift_overtime': 'Shift ended — overtime {duration}',
    'home.status': 'Status',
    'home.clocked_out_at': 'Clocked out at {time}',
    'home.not_clocked_in': 'Not clocked in yet today',
    'home.active_shift': 'Active shift',
    'home.streak': '{count} days',
    'home.policy_blocked_title': "Can't clock in yet",
    'home.policy_blocked_body': "Your workspace admin hasn't set your attendance permissions yet. Reach out to them to unlock access.",
    'home.status_loading': 'Loading attendance status…',
    'home.status_unavailable': 'Attendance status not loaded',
    'home.load_error_title': "Couldn't load your attendance status",
    'home.load_error_body': 'The server is busy or your connection dropped. Your attendance data is safe — wait a moment, then tap Try again to show the clock-in / clock-out button.',

    'home.stats.present': 'Present this month',
    'home.stats.late': 'Late this month',
    'home.stats.overtime': 'Overtime this month',
    'home.stats.avg_in': 'Avg start time',
    'home.stats.days': 'days',
    'home.stats.total': 'total',
    'home.stats.per_day': 'per day',
    'home.stats.late_total_min': '{min}m total',

    'clock.pick_mode': 'Pick work mode',
    'clock.in_now': 'Log attendance',
    'clock.out_now': 'Finish attendance',
    'clock.btn_in': 'Clock in',
    'clock.btn_out': 'Clock out',
    'clock.note_placeholder': 'Note (optional)',
    'clock.visit_target_placeholder': 'Visit destination / client name',
    'clock.visit_target_required': 'Visit destination is required.',
    'clock.visit_photo': 'Photo proof (optional)',
    'clock.visit_photo_pick': 'Pick or capture photo',
    'clock.visit_photo_ready': '✓ Photo ready',
    'clock.uploading': 'Uploading…',
    'clock.toast_in': 'Clocked in.',
    'clock.toast_out': 'Clocked out. See you tomorrow!',
    'clock.toast_failed': 'Attendance failed.',
    'clock.toast_in_other_ws': 'Clocked in to workspace {name}.',
    'clock.toast_out_other_ws': 'Clocked out of workspace {name}.',
    'clock.processing': 'Processing…',

    'gps.detecting': 'Detecting location…',
    'gps.not_detected': 'Location not detected.',
    'gps.detect_now': 'Detect now',
    'gps.in_office': 'At {name}',
    'gps.distance_from_office': '{meters}m from {name}',
    'gps.in_radius': 'Within office radius ({meters}m)',
    'gps.outside_radius': 'Outside radius — pick WFH or WFA',
    'gps.no_office': 'No office registered yet. Contact admin.',
    'gps.no_office_title': 'Office location not set',
    'gps.no_office_body': 'Workspace owner has not registered any office. Use WFH or WFA mode for now, or contact admin to register an office.',
    'gps.switch_wfh': 'Switch to WFH',
    'gps.switch_wfa': 'Switch to WFA',
    'clock.block_no_office': 'Office mode unavailable — no office location registered.',
    'clock.block_out_of_radius': 'You\'re outside office radius. Switch to WFH/WFA or move closer to office.',

    'history.7d': 'Last 7 days',
    'history.empty': 'No attendance history yet.',
    'history.this_week': 'This week',
    'history.this_week_summary': '{present} present',
    'history.this_week_late': '{count} late',
    'history.late_short': '+{min}m late',
    'history.overtime_short': '+{duration} overtime',

    'status.present': 'Present',
    'status.late': 'Late',
    'status.incomplete': 'Open',
    'status.remote': 'Remote',

    'ot.title': 'Requests',
    'ot.subtitle': 'Overtime, lateness justification, reimbursement, visit.',
    'ot.btn_new': 'New request',
    'ot.empty': 'No requests yet. Tap "New request" to start.',
    'ot.filter_all_types': 'All types',
    'ot.filter_all_status': 'All statuses',

    'ot.type.overtime': 'Overtime',
    'ot.type.lateness_excuse': 'Lateness excuse',
    'ot.type.reimbursement': 'Reimburse',
    'ot.type.visit': 'Visit',
    'ot.type.sick_leave': 'Sick leave',
    'ot.type.permission_leave': 'Permission (day off)',
    'ot.type.annual_leave': 'Annual leave',
    'ot.type.maternity_leave': 'Maternity leave',

    'ot.status.pending': 'Pending',
    'ot.status.approved': 'Approved',
    'ot.status.rejected': 'Rejected',
    'ot.status.cancelled': 'Cancelled',

    // Leave & Permission history (employee)
    'leave.title': 'Leave & Permission History',
    'leave.subtitle': 'Your sick, permission, and leave requests with their status.',
    'leave.home_hint': 'View your remaining leave & request history',
    'leave.annual_quota': 'Remaining annual leave',
    'leave.annual_used': '{used} days used this year',
    'leave.days': 'days',
    'leave.days_count': '{n} days',
    'leave.summary_hint': 'Approved days throughout {year}.',
    'leave.filter_all_types': 'All types',
    'leave.filter_all_status': 'All statuses',
    'leave.empty': 'No leave or permission requests yet.',

    'ot.form.title': 'New request',
    'ot.form.type': 'Request type',
    'ot.form.team': 'Team',
    'ot.form.team_placeholder': 'Pick a team',
    'ot.form.team_required': 'Pick a team first.',
    'ot.form.from': 'From',
    'ot.form.to': 'To',
    'ot.form.leave_from': 'Start date',
    'ot.form.leave_to': 'End date',
    'ot.form.from_required': 'Start date is required.',
    'ot.form.from_date_placeholder': 'Pick start date',
    'ot.form.to_date_placeholder': 'Pick end date',
    'ot.form.sick_note': 'Sick note (optional)',
    'ot.form.sick_note_hint': 'Pick or take a photo/PDF',
    'ot.form.annual_remaining': 'Annual leave remaining: {n} day(s)',
    'ot.form.annual_used': '{used} of {quota} days used',
    'ot.form.annual_hint': 'Your remaining annual quota will be checked by the approver.',
    'ot.form.hours': 'Hours',
    'ot.form.category': 'Category',
    'ot.form.amount': 'Amount (Rp)',
    'ot.form.location': 'Location',
    'ot.form.location_placeholder': 'Place / client name',
    'ot.form.reason': 'Reason / notes',
    'ot.form.reason_placeholder': 'Brief explanation',
    'ot.form.attachments': 'Attachments (image/PDF)',
    'ot.form.submit': 'Submit',
    'ot.form.toast_submitted': 'Request submitted, awaiting approval.',

    'ot.detail.requester': 'Requester',
    'ot.detail.from': 'From',
    'ot.detail.to': 'To',
    'ot.detail.reviewed_by': 'Reviewed by',
    'ot.detail.cancel_request': 'Cancel request',
    'ot.detail.confirm_cancel': 'Cancel this request?',
    'ot.detail.toast_cancelled': 'Request cancelled.',
    'ot.detail.no_attachments': 'No attachments.',
    'ot.detail.approve': 'Approve',
    'ot.detail.reject': 'Reject',
    'ot.detail.reject_prompt': 'Reason for rejection:',
    'ot.detail.toast_approved': 'Request approved.',
    'ot.detail.toast_rejected': 'Request rejected.',
    'ot.detail.toast_review_failed': 'Failed to process. Try again.',
    'ot.detail.waiting_level': 'Waiting for approver level {level} of {total}',
    'ot.detail.level_n': 'Level {n}',

    // Shift swap — employee
    'swap.title': 'Shift swap',
    'swap.subtitle': 'Request to swap your shift on a date with a colleague.',
    'swap.home_title': 'Shift swap',
    'swap.home_hint': 'Request to swap a shift with a colleague',
    'swap.target': 'Swap with',
    'swap.target_placeholder': 'Pick a colleague',
    'swap.date': 'Shift date',
    'swap.date_placeholder': 'Pick a date',
    'swap.reason': 'Reason (optional)',
    'swap.reason_placeholder': 'e.g. family matters',
    'swap.submit': 'Request shift swap',
    'swap.err_target': 'Pick a colleague to swap with.',
    'swap.err_date': 'Pick the shift date.',
    'swap.toast_created': 'Shift swap request sent.',
    'swap.toast_failed': 'Failed to request shift swap.',
    'swap.my_requests': 'My shift swap requests',

    'payslip.title': 'Payslip',
    'payslip.subtitle': 'Your monthly payslips with PPh21 and component breakdown.',
    'payslip.empty': 'No payslips yet.',
    'payslip.empty_hint': 'Payslips appear after admin generates monthly payroll.',
    'payslip.period': 'Period',
    'payslip.basic_salary': 'Basic salary',
    'payslip.overtime_pay': 'Overtime',
    'payslip.overtime_breakdown': 'Overtime breakdown',
    'payslip.ot_weekday_first': '1st hour (weekday)',
    'payslip.ot_weekday_after': 'Subsequent hours (weekday)',
    'payslip.ot_weekend': 'Rest day / weekend',
    'payslip.ot_holiday': 'Public holiday',
    'payslip.ot_night': 'Night premium',
    'payslip.ot_minutes': '{m} min',
    'payslip.ot_multiplier': '×{x}',
    'payslip.ot_capped': 'Capped (weekly limit)',
    'payslip.reimbursement': 'Reimbursement',
    'payslip.unpaid_leave_deduction': 'Unpaid leave deduction',
    'payslip.unpaid_leave_days': '{d} day(s)',
    'payslip.lateness_deduction': 'Lateness deduction',
    'payslip.pph21': 'Income tax (PPh21)',
    'payslip.gross': 'Gross',
    'payslip.net': 'Net pay',
    'payslip.download_pdf': 'Download PDF',
    'payslip.status.draft': 'Draft',
    'payslip.status.finalized': 'Finalized',
    'payslip.status.paid': 'Paid',

    'face.enroll_title': 'Register Your Face',
    'face.enroll_subtitle': 'Register once, then your face verifies every clock-in. Position your face inside the frame with good lighting.',
    'face.capture': 'Capture & Register',
    'face.recapture': 'Re-register Face',
    'face.analyzing': 'Analyzing face…',
    'face.loading_models': 'Preparing face detector…',
    'face.no_face': 'No face detected. Make sure your face is clear and well-lit.',
    'face.enroll_success': 'Face registered successfully.',
    'face.enroll_failed': 'Failed to register face. Try again.',
    'face.error_models': 'Failed to load face models. Check your connection.',
    'face.error_camera': 'Cannot access camera. Allow camera access and try again.',
    'face.error_generic': 'Something went wrong. Try again.',
    'face.done_title': 'Face registered!',
    'face.done_body': 'Your attendance will now be verified automatically.',
    'face.back_home': 'Back to home',
    'face.already_enrolled_title': 'Face already registered',
    'face.already_enrolled_body': 'Only re-register if your appearance changed a lot or verification keeps failing.',
    'face.privacy_note': 'Only a mathematical face pattern (numbers) is stored, never a photo. Used solely for attendance verification.',
    'face.card_setup_title': 'Enable face verification',
    'face.card_setup_hint': 'Register your face for safer, buddy-punch-proof attendance.',
    'face.card_enrolled_title': 'Face verification active',
    'face.card_enrolled_hint': 'Your attendance is verified automatically. Tap to re-register.',

    'pwa.install_title': 'Install to home screen',
    'pwa.install_body': 'Faster access without opening browser. One-time install.',
    'pwa.install_btn': 'Install',
    'pwa.install_dismiss': 'Later',
    'pwa.ios_title': 'Install on iPhone',
    'pwa.ios_step1': 'Tap Share button in Safari',
    'pwa.ios_step2': 'Choose "Add to Home Screen"',

    'push.optin_title': 'Enable notifications',
    'push.optin_body': 'Get reminders for shift start, approval results, and payslip ready straight to your device.',
    'push.optin_btn': 'Enable',
    'push.optin_dismiss': 'Skip',
    'push.toast_enabled': 'Notifications enabled.',
    'push.toast_failed': 'Failed to enable notifications.',

    'error.network': 'No internet connection.',
    'error.offline_banner': 'You are offline. Data may be outdated.',
};
